// setInterval that pauses while the tab is hidden and refreshes once when it becomes visible again.
export function visibleInterval(fn, ms) {
  const t = setInterval(() => { if (document.visibilityState === "visible") fn(); }, ms);
  const onVis = () => { if (document.visibilityState === "visible") fn(); };
  document.addEventListener("visibilitychange", onVis);
  return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVis); };
}
